const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.fans.nextremedy.net";

export default API_BASE_URL;